export default "__VITE_ASSET__Cuwt7RMm__"